var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.087,
    height: 37.788,
    viewBox: "0 0 37.087 37.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0.801 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pin_Icon",
    "data-name": "Pin Icon",
    d: "M24.029.171,35.072,11.465a.461.461,0,0,1,0,.641l-3.761,3.846a.436.436,0,0,1-.626,0l-1.069-1.093-4.957,5.068a13.049,13.049,0,0,1-3.257,12.4q-.114.117-.231.231c-.288.28-.242.278-.52-.006l-7.015-7.175L0,36.038,10.427,22.1,3.4,14.911c-.28-.287-.257-.242.019-.538q.1-.112.21-.221a12.373,12.373,0,0,1,12.124-3.332l4.955-5.069L19.641,4.658a.463.463,0,0,1,0-.641L23.4.171a.438.438,0,0,1,.627,0Z",
    transform: "translate(0 -0.038)",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPinIcon);
export default __webpack_public_path__ + "static/media/MenuPinIcon.3a8f5eb951a15df97ee137dd557f30d9.svg";
export { ForwardRef as ReactComponent };